import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

//STYLES
import * as SectionsStyles from "./styles/sections";

//COMPONENTS
import PageViewer from "../../../../administration/pods/pageViewer/pageViewer";

function ContentSection(props) {
    const navigate = useNavigate();
    const GS_generalSettings = useSelector((state) => state.GS_generalSettings);
    const content = useRef(null);
    const [seeMoreButton, setSeeMoreButton] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            //console.log(content.current.offsetHeight);
            if (content.current.offsetHeight >= 1000) {
                setSeeMoreButton(true);
            }
        }, 100);
    });

    function seeMoreNavigate(editorialUUID) {
        navigate(`./page/${editorialUUID}`);
    }

    return (
        <div style={GS_generalSettings.isMobile ? SectionsStyles.mobile_contentContianer : SectionsStyles.contentContianer}>
            <div ref={content} style={SectionsStyles.content}>
                <PageViewer pageID={props.pageID} />
            </div>
            {seeMoreButton && (
                <div style={SectionsStyles.seeMore} onClick={seeMoreNavigate.bind(this, "1")}>
                    See More
                </div>
            )}
        </div>
    );
}

export default ContentSection;
